import React from "react";
import "../styles/RtgsNeft.css";

function RtgsNeft() {
  return (
    <div className="rtgs-page">

      {/* HERO */}

      <section className="rtgs-hero">
          <h1>RTGS / NEFT </h1>
          <p>
            Transfer money safely and quickly anywhere in India using our
            secure banking transfer systems.
          </p>
      </section>

      {/* INTRO */}

      <section className="transfer-intro">

        <div className="transfer-card rtgs">
          <h2>RTGS</h2>
          <h4>Real Time Gross Settlement</h4>

          <p>
            RTGS allows high value transactions to be transferred instantly
            between banks across India. Transactions are processed
            individually in real-time.
          </p>

          <div className="limit-box">
            Minimum Transfer Amount
            <strong>₹2,00,000</strong>
          </div>

          <ul>
            <li>Real-time settlement</li>
            <li>Safe and secure banking network</li>
            <li>No maximum transaction limit</li>
            <li>Ideal for high value transfers</li>
          </ul>

        </div>


        <div className="transfer-card neft">

          <h2>NEFT</h2>
          <h4>National Electronic Fund Transfer</h4>

          <p>
            NEFT is a nationwide payment system that allows individuals,
            businesses and firms to transfer funds from one bank account to
            another anywhere in India.
          </p>

          <div className="limit-box">
            Transfer Amount
            <strong>No Minimum Limit</strong>
          </div>

          <ul>
            <li>Nationwide bank transfers</li>
            <li>Secure centralized system</li>
            <li>Convenient for daily transactions</li>
            <li>Reliable and trusted transfer method</li>
          </ul>

        </div>

      </section>

      {/* TIMINGS */}

      <section className="transfer-timings">

        <h2>Transaction Timings</h2>

        <div className="timing-grid">

          <div className="timing-card">
            <h3>RTGS Timings</h3>

            <p><strong>Monday - Friday</strong></p>
            <p>8:00 AM – 4:00 PM</p>

            <p><strong>Saturday</strong></p>
            <p>8:00 AM – 4:00 PM</p>

            <p className="note">
              (Except 2nd and 4th Saturday)
            </p>

            <p><strong>Weekly Off</strong></p>
            <p>Sunday</p>

          </div>


          <div className="timing-card">

            <h3>NEFT Timings</h3>

            <p><strong>Monday - Friday</strong></p>
            <p>8:00 AM – 6:00 PM</p>

            <p><strong>Saturday</strong></p>
            <p>8:00 AM – 6:00 PM</p>

            <p className="note">
              (Except 2nd and 4th Saturday)
            </p>

            <p><strong>Weekly Off</strong></p>
            <p>Sunday</p>

          </div>

        </div>

      </section>

      {/* HOW IT WORKS */}

      <section className="transfer-steps">

        <h2>How to Transfer Funds</h2>

        <div className="steps-grid">

          <div className="step">
            <span>1</span>
            <p>Visit your nearest bank branch</p>
          </div>

          <div className="step">
            <span>2</span>
            <p>Fill RTGS / NEFT transfer form</p>
          </div>

          <div className="step">
            <span>3</span>
            <p>Provide beneficiary account details</p>
          </div>

          <div className="step">
            <span>4</span>
            <p>Funds transferred to beneficiary bank</p>
          </div>

        </div>

      </section>

      {/* IMPORTANT INFO */}

      <section className="transfer-info">

        <h2>Important Information</h2>

        <div className="info-box">

          <p>
            • RTGS transactions are processed individually and instantly.
          </p>

          <p>
            • NEFT transactions are processed through a centralized banking
            system across India.
          </p>

          <p>
            • Transactions are subject to RBI regulations and bank policies.
          </p>

          <p>
            • Ensure beneficiary details such as account number and IFSC code
            are correct before initiating the transaction.
          </p>

        </div>

      </section>

      {/* CTA */}

      <section className="transfer-cta">

        <h2>Need Help With Fund Transfer?</h2>

        <p>
          Visit your nearest branch or contact our support team for assistance.
        </p>

        <a href="/contact" className="transfer-btn">
          Contact Bank
        </a>

      </section>

    </div>
  );
}

export default RtgsNeft;